import {Injectable, Inject} from '@angular/core';

import {IdTokenClaimsWithPolicyId} from "../app.component";
import {MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration} from "@azure/msal-angular";
import {InteractionType} from '@azure/msal-browser';


@Injectable({
  providedIn: 'root',
})
export class AuthService{
  private token: IdTokenClaimsWithPolicyId | undefined;

  constructor(
    private msalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {
  }

  getUserRole(): (string)[] {
    const accountInfo = this.msalService.instance.getActiveAccount();
    this.token = accountInfo?.idTokenClaims as IdTokenClaimsWithPolicyId;

    return [this.token?.extension_CrmAccountRole];
  }

  logout(redirectUrl?: string): void {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.msalService.logoutPopup({
        mainWindowRedirectUri: redirectUrl || "/login"
      });
    } else {
      if (redirectUrl) {
        this.msalService.logoutRedirect({
          postLogoutRedirectUri: redirectUrl
        });
      } else {
        this.msalService.logoutRedirect();
      }
    }
  }
}
